var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0072b2;}.cls-2{fill:#00a0df;}.cls-3{fill:#b3b3b3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_134",
    "data-name": "Layer 134"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.35,112.71H140.92A28.11,28.11,0,0,1,112.8,84.6V28.37A28.12,28.12,0,0,1,140.92.26H459.53a28.11,28.11,0,0,1,28.11,28.11V84.6a28.1,28.1,0,0,1-28.11,28.11H190.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.71,412.58H497a28.1,28.1,0,0,0,28.11-28.11c0-59.44-43.88-106.8-100.7-133.23L410.09,112.71H190.35L176,251.24C119.2,277.67,75.32,325,75.32,384.47a28.11,28.11,0,0,0,28.11,28.11H337.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M337.71,412.58c-.15,52,8.56,109.86-16,156.94Q316.33,579.75,311,590c-2.36,4.49-5.91,9.57-10.77,10.26-4.86-.69-8.4-5.77-10.77-10.26q-5.34-10.26-10.68-20.48c-24.6-47.08-15.89-104.94-16-156.94Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.1d6519236df03d73ef4e4919a7fede1d.svg";
export { ForwardRef as ReactComponent };